import { Banner, HeaderSection, OtherSection, SpecialOffer } from 'common/components';
import { Layout } from 'fronton-react';
import React from 'react';
import {
  KitchenAdditionalSection,
  KitchenDeliniaSection,
  KitchenDesignPanel,
  KitchenDesignSection,
  KitchenGallerySection,
} from './components';
import {
  KITCHEN_HEADER_IMAGE_LIST,
  KITCHEN_RENOVATION,
  KITCHEN_LANDING_NAME,
} from './old-kitchen-constants';
import { KITCHEN_ELEMENT_BLOCK } from '../kitchen-constants';

type OldKitchenProps = {
  regionId: string;
};

export const OldKitchen: React.FC<OldKitchenProps> = ({ regionId }) => (
  <>
    <HeaderSection
      imgList={KITCHEN_HEADER_IMAGE_LIST}
      bgColor="#F2F3F5"
      description="Уникальное сочетание цветов, материалов и&nbsp;декоративных элементов для вашей кухни. Бесплатно спроектируйте кухню вместе с&nbsp;опытным консультантом."
      mediaType="carousel"
      title="Кухни под вашу планировку"
      textColor="text-primary"
    />
    <KitchenDesignPanel regionId={regionId} />
    <Layout>
      <SpecialOffer isNewAnalytics regionId={regionId} elementBlock={KITCHEN_ELEMENT_BLOCK} />
      <KitchenDesignSection regionId={regionId} />
      <KitchenGallerySection />
      <Banner {...KITCHEN_RENOVATION} />
      <KitchenAdditionalSection />
      <KitchenDeliniaSection />
    </Layout>
    <OtherSection
      elementBlock={`${KITCHEN_ELEMENT_BLOCK} / other`}
      landingName={KITCHEN_LANDING_NAME}
      promotionName={`${KITCHEN_ELEMENT_BLOCK}_bottom`}
    />
  </>
);
